var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d-container',{attrs:{"fluid":""}},[_c('d-row',[_c('d-col',{staticClass:"main-content mb-4 p-0",attrs:{"tag":"main","lg":"12","md":"12","sm":"12"}},[_c('div',{attrs:{"id":"scroll-detector"}}),_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }